<script>
import UploadPopover from "@/components/widgets/upload-popover.vue";

export default {
  props: {
    propertyRow: {
      type: Object,
      required: true,
    },
  },
  components: {
    UploadPopover,
  },
  data() {
    return {
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Property",
        placement: "lefttop",
        folder: "Property",
      },
    };
  },
  methods: {
    uploadDocument(response) {
      this.propertyRow.propertyFiles.push(response);
    },
    openDocument(x) {
      this.readFile(x.id)
    },
    searchDocu(row) {
      let data = row.propertyFiles;
      if (row.fileSearch.trim() != "" && row.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(row.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    async getAttachments(row) {
      row.attachmentVisible = !row.attachmentVisible;
      if (row.attachmentVisible) {
        row.propertyFiles = [];
        row.fileSearch = "";
        row.attachmentLoading = true;
        await this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: "Property",
          })
          .then((res) => {
            res.data.forEach((item) => {
              row.propertyFiles.push(item);
            });
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting documents!",
              "error"
            );
          });
        await setTimeout(() => {
          row.attachmentLoading = false;
        }, 800);
      }
    },
    removeFile(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.itemIndex = this.propertyRow.propertyFiles.findIndex(
                (item) => item.id == props.id
              );
              this.propertyRow.propertyFiles.splice(this.itemIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <b-card-body
      class="border cursor-pointer"
      @click="getAttachments(propertyRow)"
    >
      <div class="d-flex align-items-center justify-content-between">
        <h6 class="mb-0">
          <i class="bx bx-paperclip rotate rotate-90"></i>
          Attachments
        </h6>
        <h5 class="mb-0">
          <i
            class="bx bx-chevron-right rotate"
            :class="{
              'rotate-90': propertyRow.attachmentVisible,
            }"
          ></i>
        </h5>
      </div>
    </b-card-body>
    <b-collapse :visible="propertyRow.attachmentVisible" role="tabpanel">
      <div v-if="propertyRow.attachmentVisible">
        <b-card-body v-if="propertyRow.attachmentLoading" class="border">
          <div class="d-flex align-items-center justify-content-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
        </b-card-body>
        <b-card-body v-else class="border">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex">
              <p class="mb-0" v-if="propertyRow.propertyFiles.length == 0">
                <i>No documents found</i>
              </p>
              <input
                v-if="propertyRow.propertyFiles.length > 0"
                type="search"
                class="form-control"
                v-model="propertyRow.fileSearch"
                placeholder="Search Documents..."
                autocomplete="off"
              />
            </div>
            <div>
              <a
                href="javascript:void(0);"
                class="text-primary border-primary border p-2"
                :id="`posted-document${propertyRow.id}`"
                @click="propertyRow.addDocu = true"
                ><i class="bx bx-plus"></i>Upload Documents</a
              >
              <upload-popover
                :option="uploadOptions"
                :sourceId="propertyRow.id"
                @uploaded="uploadDocument($event)"
                :showPV="propertyRow.addDocu"
                @closePopover="propertyRow.addDocu = false"
                :dzId="`dropzone-posted${propertyRow.id}`"
                :pvId="`posted-document${propertyRow.id}`"
              ></upload-popover>
            </div>
          </div>
          <div class="mt-2">
            <b-row>
              <b-col
                sm="3"
                v-for="(y, index) in searchDocu(propertyRow)"
                :key="y.id"
                class="mb-2"
              >
                <div
                  class="position-relative cursor-pointer"
                  :style="`z-index: ${
                    propertyRow.propertyFiles.length - index
                  }`"
                >
                  <div class="float-end ms-2">
                    <b-dropdown
                      id="dropdown-dropleft"
                      right
                      variant="link"
                      toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                      menu-class="dropdown-menu-end"
                      no-caret
                    >
                      <template #button-content>
                        <i class="mdi mdi-dots-horizontal"></i>
                      </template>
                      <b-dropdown-item @click="openDocument(y)"
                        ><i class="bx bx-link-external me-1"></i
                        >Open</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          isAdmin ||
                          y.applicationUserId == token.ApplicationUserId
                        "
                        variant="danger"
                        @click="removeFile(y)"
                        ><i class="bx bx-trash me-1"></i>Remove</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="border p-3" @click="openDocument(y)">
                    <div>
                      <div class="avatar-xs me-3 mb-2">
                        <div class="avatar-title bg-transparent rounded">
                          <i
                            v-if="y.fileType.includes('image')"
                            class="mdi mdi-image font-size-24 text-purple"
                          ></i>
                          <i
                            v-if="y.fileType.includes('application')"
                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                          ></i>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="overflow-hidden me-auto">
                          <h5 class="font-size-14 text-truncate mb-1">
                            {{ y.description }}
                          </h5>
                          <p class="text-muted mb-0">
                            {{
                              formatDateWithTime(new Date(y.dateTimeUploaded))
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="
                searchDocu(propertyRow).length == 0 && propertyRow.fileSearch
              "
            >
              <b-col>Search Not Found</b-col>
            </b-row>
          </div>
        </b-card-body>
      </div>
    </b-collapse>
  </div>
</template>
